module.exports = __webpack_public_path__ + "static/media/iconfinder_Address_Book_Old_school_Alt_red_86955.f471f9c8.png";